import axios from "axios";
import store from "../redux/store/store";
const API_BASE_URL = import.meta.env.VITE_API_URL;

const placesCategoryService = {

    // Places Category Ekleme
    addPlacesCategory: async (categoryData, token) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.post(
                `${API_BASE_URL}/PlaceCategory`,
                categoryData,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Kategori eklenirken bir hata oluştu:", error);
            if (error.response && error.response.data) {
                console.error("Hata yanıtı:", error.response.data);
            }
            throw error; 
        }
    },

    // Places Category Getirme
    fetchPlaceCategories: async (queryModel) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.get(`${API_BASE_URL}/PlaceCategory`, {
                params: queryModel,
                headers:{  Authorization: `Bearer ${userToken}`}
            });
            return response.data; // Başarılı durumda gelen veri
        } catch (error) {
            console.error("PlaceCategory verileri alınırken hata oluştu:", error);
            throw error; // Hata durumunda çağıran tarafı bilgilendir
        }
    },

// Places Category Silme
deletePlacesCategory: async (id, token) => {
    if (!id) {
        console.error("Silme işlemi için geçerli bir ID sağlanmadı.");
        throw new Error("Silme işlemi için geçerli bir ID sağlanmadı.");
    }

    try {
        const userToken = store.getState()?.auth?.user?.accessToken?.token;
        const response = await axios.delete(
            `${API_BASE_URL}/PlaceCategory`,
            {
                params: { id }, // Query parametre olarak ID gönderimi
                headers: {
                    Authorization: `Bearer ${userToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
       
        return response.data;
    } catch (error) {
        console.error("Kategori silinirken bir hata oluştu:", error);

        // Hata yanıtı varsa detaylı bilgi ekle
        if (error.response) {
            console.error("Hata Kodu:", error.response.status);
            console.error("Hata Mesajı:", error.response.data || error.response.statusText);
        } else {
            console.error("Sunucuya ulaşılamadı veya başka bir hata oluştu.");
        }

        throw error; // Hata durumunu çağıran tarafa ilet
    }
},

};

export default placesCategoryService;
